import { PayloadAction } from "@reduxjs/toolkit";
import { UpsellState } from "../../models/UpsellsState";
import { DeleteUpsellPayload } from "../../payload/DeleteUpsell/DeleteUpsellPayload";

const deleteAdditionalFetch = (state: UpsellState, action: PayloadAction<DeleteUpsellPayload>) => {
    state.isLoading = true;
}

export default deleteAdditionalFetch;